import { LayoutDashboard, Users, Pill, Package, Warehouse } from 'lucide-react';

const BottomNavigation = ({ activeTab, dispatch, queueCount }) => {
  const tabs = [
    { id: 'dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { id: 'customers', icon: Users, label: 'Customers' },
    { id: 'dispensing', icon: Pill, label: 'Dispense', badge: queueCount },
    { id: 'orders', icon: Package, label: 'Orders' },
    { id: 'inventory', icon: Warehouse, label: 'Inventory' }
  ];

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 glass border-t border-white/30 z-20 safe-area-bottom">
      <div className="flex justify-around py-1.5 max-w-2xl mx-auto">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => dispatch({ type: 'SET_ACTIVE_TAB', payload: tab.id })}
            className={`flex flex-col items-center py-2 px-3 relative rounded-xl transition-all duration-300 ${
              activeTab === tab.id || (tab.id === 'customers' && activeTab === 'customer-detail')
                ? 'text-brand-600'
                : 'text-gray-400 hover:text-gray-600'
            }`}
            aria-label={tab.label}
          >
            {(activeTab === tab.id || (tab.id === 'customers' && activeTab === 'customer-detail')) && (
              <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-8 h-1 bg-gradient-to-r from-brand-500 to-accent-500 rounded-full animate-scale-in" />
            )}
            <div className="relative">
              <tab.icon className={`h-5 w-5 transition-transform duration-200 ${activeTab === tab.id ? 'scale-110' : ''}`} />
              {tab.badge > 0 && (
                <div className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center font-bold animate-bounce-in">
                  {tab.badge}
                </div>
              )}
            </div>
            <span className={`text-[10px] mt-1 font-medium transition-all ${activeTab === tab.id ? 'opacity-100' : 'opacity-70'}`}>
              {tab.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;
